var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageLinkArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "25px",
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dev-portal-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lp-op2",
    transform: "translate(-852.000000, -1629.000000)",
    fill: "#7A4DFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Industry-regular-Copy-9",
    transform: "translate(323.000000, 1451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(328.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/magnify-copy-8",
    transform: "translate(215.531197, 17.500000) rotate(-360.000000) translate(-215.531197, -17.500000) translate(201.375000, 5.833333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2395307,0.427135944 C11.8090453,-0.142378648 12.7324109,-0.142378648 13.3019255,0.427135944 C13.8714401,0.996650536 13.8714401,1.92001613 13.3019255,2.48953072 L5.582,10.208 L26.8540614,10.2083333 C27.6120993,10.2083333 28.2350532,10.7866967 28.3057189,11.5262194 L28.3123948,11.6666667 C28.3123948,12.4720819 27.6594767,13.125 26.8540614,13.125 L5.583,13.125 L13.3019255,20.8438026 C13.8358454,21.3777225 13.8692154,22.2226443 13.4020355,22.7954395 L13.3019255,22.9061974 C12.7324109,23.475712 11.8090453,23.475712 11.2395307,22.9061974 L-1.98875275e-14,11.6666667 Z",
    id: "Combined-Shape",
    transform: "translate(14.156197, 11.666667) rotate(-180.000000) translate(-14.156197, -11.666667) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageLinkArrow);
export default __webpack_public_path__ + "static/media/homepage-link-arrow.cac0f53dfb9eeafb23a5efd1a8e1bab8.svg";
export { ForwardRef as ReactComponent };